import { Typography } from 'antd';
import React from 'react';
import { supportedTextStyles } from '../../pages/Auth/styles';
import AuthFotterImg from '../../Assets/AuthFotter.png';
import { useTranslate } from '@refinedev/core';
export const AuthFotter = () => {
  const translate = useTranslate();

  return (
    <div
      style={{
        display: 'flex',
        alignItems: 'center',
      }}
    >
      <Typography style={{ ...supportedTextStyles }}>
        {translate('pages.login.poweredBy', 'مدعوم من')}
      </Typography>
      <img src={AuthFotterImg} alt="login" />
    </div>
  );
};
